import axiosInstance from '../../config';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
// const host = "http://localhost:5000/api/";
import { CircularProgress } from '@mui/material';

export default function CloseFriend(props) {
  const [user, setuser] = useState({});
  const [loading, setloading] = useState(false);

  const fetchuserfun = async () => {
    try {
      setloading(true);
      const response = await axiosInstance.get("/api/" + "users?userId=" + props.id);
      setuser(response.data);
      setloading(false);
    } catch (error) {
      console.log("inside closedfriend", error);
    }
  }

  useEffect(() => {
    if (props.id) {
      fetchuserfun();
    } else {
      setuser(props.user);
    }
  }, []);

  // const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const PF = "https://socialshub.netlify.app/images/";

  return (
    <div key={user._id} className="friendProfile">
      {loading?<CircularProgress size={15}/>:<>
        <div className="friendLeft">
          <Link style={{'textDecoration':'none'}} to={'/profile/' + user._id}><img src={user.profilePic ?  user.profilePic : PF + "person/noprofile.png"} className="shareProfileImg" style={{ "marginRight": '0px' }} /></Link>
        </div>
        <div className="friendRigth">
          <Link style={{'textDecoration':'none'}} to={'/profile/' + user._id}><h4>{user.username}</h4></Link>
          <div className="conformBtn">
            <Link style={{'textDecoration':'none'}} to={'/profile/' + user._id}><button className='firstbtn'>View Profile</button></Link>
          </div>
        </div>
      </>}
    </div>
  );
}